var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"rating-container"},_vm._l((_vm.stars),function(star,index){return _c('span',{key:index,class:star.type},[_vm._v("★")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }